module.exports = __webpack_public_path__ + "img/umbrella-family.4445a9b8.png";